import { ButtonV2, TextArea, TextInput } from '@cimplico/components';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toastNotification } from '../../components/toast/Toast';
import { useFirmContext } from '../../providers/FirmProvider';
import { useWorkpaperContext } from '../../providers/WorkpaperProvider';
import { useCreateOtherSchedules } from '../../queries/use-create-other-schedule';
import { WorksheetTypeEnum } from '../../types/worksheet';

type CreateOtherScheduleParams = {
    name: string;
    tag?: string;
    description?: string;
};

type ManualFormProps = {
    onCancel: () => void;
};

function ManualForm({ onCancel }: ManualFormProps): JSX.Element {
    const { id } = useWorkpaperContext();
    const { shortId } = useFirmContext();
    const navigate = useNavigate();
    const createOSQuery = useCreateOtherSchedules(id);

    const form = useForm<CreateOtherScheduleParams>();

    function handleSubmit(values: CreateOtherScheduleParams): void {
        const { name, description, tag } = values;
        createOSQuery.mutate([{ name, description, tag, type: WorksheetTypeEnum.GENERIC }], {
            onSuccess(data) {
                const worksheet = data.results[0].data;
                if (worksheet) {
                    toastNotification('success', `Successfully created ${worksheet?.name}`);
                    navigate(`/${shortId}/workpapers/${id}/other-schedules/${worksheet?.id}`);
                }
            },
            onError(error) {
                const err = error.response?.data?.results?.at(0)?.error;
                if (err) {
                    form.setError('name', { message: err.fields?.name });
                }
            },
        });
    }

    return (
        <form className="flex flex-col gap-4 w-[450px]" onSubmit={form.handleSubmit(handleSubmit)}>
            {/* Worksheet name */}
            <Controller
                control={form.control}
                name="name"
                rules={{ required: 'A name is required.', maxLength: 50 }}
                render={({ field, fieldState }): JSX.Element => {
                    return (
                        <TextInput
                            placeholder="e.g. Tax Reconciliation"
                            title="Name"
                            defaultValue={field.value}
                            onChange={field.onChange}
                            errorMessage={fieldState.error?.message}
                            characterLimit={50}
                            autoFocus
                        />
                    );
                }}
            />
            {/* Worksheet tag (optional) */}
            <Controller
                control={form.control}
                name="tag"
                render={({ field }): JSX.Element => (
                    <TextInput
                        isOptional
                        placeholder="Enter a value..."
                        title="Tag"
                        defaultValue={field.value}
                        onChange={field.onChange}
                        characterLimit={50}
                    />
                )}
            />
            {/* Worksheet description (optional) */}
            <Controller
                control={form.control}
                name="description"
                render={({ field }): JSX.Element => (
                    <TextArea
                        title="Description"
                        isOptional
                        defaultValue={field.value}
                        onChange={field.onChange}
                        placeholder="A brief description about the worksheet..."
                        characterLimit={250}
                    />
                )}
            />
            <div className="flex justify-end gap-4">
                <ButtonV2 size="sm" type="hollow" label="Cancel" onClick={onCancel} />
                <ButtonV2
                    size="sm"
                    type="primary"
                    label={createOSQuery.isLoading ? 'Creating...' : 'Create'}
                    isDisabled={createOSQuery.isLoading}
                    isLoading={createOSQuery.isLoading}
                    isSubmit
                />
            </div>
        </form>
    );
}

export default ManualForm;

// {/* SCHEDULE TAG */}
// <TextInput
// isOptional
// placeholder="Enter a value"
// title="Schedule tag"
// defaultValue={name}
// onChange={setTag}
// characterLimit={50}
// />

// {/* SCHEDULE DESCRIPTION */}
// <TextArea
// title="Description"
// isOptional
// defaultValue={description}
// onChange={setDescription}
// placeholder="Description..."
// characterLimit={250}
// />
